export default __webpack_public_path__ + "static/media/cai-design03.6977036c.jpg";